import React from 'react';

import { Button, Logo } from '@ergeon/core-components';
import { Bars3Icon } from '@ergeon/icons/hero/micro';

import TopPanelRightSide from './TopPanelRightSide';
import MobileMenu from './MobileMenu';
import { useMobileMenu } from './useMobileMenu';
import { TopPanelProps } from './types';

const TopPanel: React.FC<TopPanelProps> = ({ ergeonUrl }) => {
  const { isOpen, open, close } = useMobileMenu();

  return (
    <>
      <header className="bg-white border-gray-200 border-b">
        <div className="mx-auto max-w-7xl">
          <div className="flex justify-between items-center px-4 h-16">
            <Logo href={ergeonUrl} size="large" />
            <TopPanelRightSide ergeonUrl={ergeonUrl} />
            <Button
              aria-label="Open menu"
              className="md:hidden"
              flavor="regular"
              isSquare
              onClick={open}
              taste="boundless">
              <Bars3Icon className="size-6" />
            </Button>
          </div>
        </div>
      </header>
      <MobileMenu ergeonUrl={ergeonUrl} isOpen={isOpen} onClose={close} />
    </>
  );
};

export default TopPanel;
